(function () {
  // Force the page to always start at the top on load. Mobile browsers can
  // otherwise restore the last scroll position (or jump to a URL anchor),
  // which made the entry gate/page appear to load scrolled to the bottom.
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }
  window.scrollTo(0, 0);

  var LEAVE_DURATION = 430;
  var SCROLL_SETTLE_DELAY = 60;
  var FLY_DURATION = 600;

  function initGate(gate) {
    var sessionKey = gate.dataset.sessionKey || 'intro-gate-seen';
    var inThemeEditor = window.Shopify && window.Shopify.designMode;

    if (!inThemeEditor && sessionStorage.getItem(sessionKey) === '1') {
      gate.hidden = true;
      return;
    }

    var ctaButton = gate.querySelector('[data-fp-gate-cta]');
    var skipButton = gate.querySelector('[data-fp-gate-skip]');
    var ctaLink = gate.dataset.ctaLink;
    var scrollTargetId = gate.dataset.scrollTarget;
    var leaving = false;

    document.documentElement.classList.add('fp-gate-lock');

    function findRealCta() {
      if (!scrollTargetId) return null;
      var container = document.getElementById(scrollTargetId);
      if (!container) return null;
      return container.querySelector('.fp-bh-cta, [data-fp-bh-cta-label]');
    }

    function makeFlyEl(rect, label, fontSize) {
      var el = document.createElement('div');
      el.className = 'fp-fly-cta';
      el.textContent = label;
      el.style.top = rect.top + 'px';
      el.style.left = rect.left + 'px';
      el.style.width = rect.width + 'px';
      el.style.height = rect.height + 'px';
      el.style.fontSize = fontSize;
      document.body.appendChild(el);
      return el;
    }

    function flyElTo(el, rect, fontSize) {
      // force a reflow so the change below is transitioned, not instant
      void el.offsetWidth;
      el.style.top = rect.top + 'px';
      el.style.left = rect.left + 'px';
      el.style.width = rect.width + 'px';
      el.style.height = rect.height + 'px';
      el.style.fontSize = fontSize;
    }

    function close(scrollToBuy) {
      if (leaving) return;
      leaving = true;
      sessionStorage.setItem(sessionKey, '1');

      var flyEl = null;
      var realTargetBtn = null;

      if (scrollToBuy && ctaButton) {
        realTargetBtn = findRealCta();

        if (realTargetBtn) {
          var startRect = ctaButton.getBoundingClientRect();
          var startFont = window.getComputedStyle(ctaButton).fontSize;
          var label = realTargetBtn.textContent.trim();

          ctaButton.textContent = label;
          ctaButton.style.opacity = '0';
          flyEl = makeFlyEl(startRect, label, startFont);
        }
      }

      gate.classList.add('fp-gate-leaving');
      document.removeEventListener('keydown', onKeydown);

      window.setTimeout(function () {
        gate.hidden = true;
        document.documentElement.classList.remove('fp-gate-lock');

        if (!scrollToBuy) return;

        var container = scrollTargetId ? document.getElementById(scrollTargetId) : null;

        if (!container) {
          if (flyEl && flyEl.parentNode) flyEl.parentNode.removeChild(flyEl);
          if (ctaLink) window.location.href = ctaLink;
          return;
        }

        // Land at the very top of the page (product images) instead of
        // scrolling/jumping down to chase the flying CTA button. The fly
        // animation is still fine to watch, it just shouldn't drag the
        // viewport down with it on mobile.
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        window.setTimeout(function () {
          if (flyEl && realTargetBtn) {
            var endRect = realTargetBtn.getBoundingClientRect();
            var endFont = window.getComputedStyle(realTargetBtn).fontSize;
            realTargetBtn.style.opacity = '0';
            flyElTo(flyEl, endRect, endFont);

            window.setTimeout(function () {
              realTargetBtn.style.opacity = '';
              if (flyEl && flyEl.parentNode) flyEl.parentNode.removeChild(flyEl);
            }, FLY_DURATION + 20);
          } else if (flyEl && flyEl.parentNode) {
            flyEl.parentNode.removeChild(flyEl);
          }
        }, SCROLL_SETTLE_DELAY);
      }, LEAVE_DURATION);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close(false);
    }

    if (ctaButton) ctaButton.addEventListener('click', function () { close(true); });
    if (skipButton) skipButton.addEventListener('click', function () { close(false); });
    document.addEventListener('keydown', onKeydown);
  }

  var gates = document.querySelectorAll('[data-fp-gate]');
  gates.forEach(initGate);
})();
